import AuthService from "./Application/User/AuthService";
import PrivateApp from "./pages/private/PrivateApp.js";
import PublicApp from "./pages/public/PublicApp.js";
import { ThemeProvider, CssBaseline, useMediaQuery } from "@mui/material";
import { EnvTool } from "./pages/DevTool";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import "pages/translations/i18n"; // Import the i18n configuration
import useCustomTheme from "pages/Hooks/useCustomTheme";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import { useEventListener } from "pages/Hooks/useEventListener";
import { LOGGED_IN, SNACK_NOTIFICATION } from "pages/constants/EventKeys";
import { useTranslation } from "react-i18next";
import Modal from "pages/components/Modal";
import { CheckAuth } from "Application/User/LoginService";
import { useEffect, useRef, useState } from "react";
import GlobalLoader from "pages/components/GlobalLoader";
import AlertDialog from "pages/components/AlertDialog";
import { useNavigate } from "react-router-dom";
import { getUrl, HOME } from "Infrastructure/config/routesConfig";

export default function App() {
  const [isLoading, setIsLoading] = useState(true);
  const appInitiated = useRef(false);

  useEffect(() => {
    if (!appInitiated.current) {
      CheckAuth().then((res) => {
        setIsLoading(false);
      });
      appInitiated.current = true;
    }
  }, []);

  return isLoading ? <GlobalLoader /> : <CustomApp />;
}

function CustomApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(AuthService.isAuthenticated());
  const theme = useCustomTheme();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEventListener(LOGGED_IN, () => {
    setIsLoggedIn(true);
    navigate(getUrl(HOME));
  });

  useEventListener(SNACK_NOTIFICATION, (res) => {
    const variant = res.snackVariant;
    const message = `${t(`FEEDBACK.SNACK.${res.type}`)} : ${t(
      `FEEDBACK.SNACK.${variant}`
    )}`;
    enqueueSnackbar(message, {
      variant: variant,
    });
  });
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale={i18n?.language}
    >
      <ThemeProvider theme={theme}>
        <Modal />
        <AlertDialog />
        <CssBaseline />
        <SnackbarProvider
          maxSnack={isMobile ? 2 : 3}
          anchorOrigin={{
            horizontal: "right",
            vertical: isMobile ? "bottom" : "top",
          }}
        >
          {
            isLoggedIn ? <PrivateApp /> : <PublicApp />
          }
        </SnackbarProvider>
        {/* <DevTool /> */}
        <EnvTool />
      </ThemeProvider>
    </LocalizationProvider>
  );
}
